/**
 * Resolve the 10Seat API base URL.
 * Pure function — no framework dependencies.
 * Each app calls this with its own environment values.
 */
export function resolveApiBaseUrl(options?: {
  explicitUrl?: string;
  projectId?: string;
  isDev?: boolean;
  useEmulator?: boolean;
}): string {
  const { explicitUrl, projectId = '', isDev = false, useEmulator = false } = options ?? {};

  // 1. Explicit override takes priority
  if (explicitUrl) return explicitUrl;

  // 2. Local emulator
  if (isDev && useEmulator && projectId) {
    return `http://localhost:5002/${projectId}/europe-west1/api`;
  }

  // 3. Dev without emulator (still hits local)
  if (isDev && projectId) {
    return `http://localhost:5002/${projectId}/europe-west1/api`;
  }

  // 4. Cloud Run URLs by project
  if (projectId === 'staging-10seat') {
    return 'https://api-yg3d7qeboa-ew.a.run.app';
  }
  return 'https://api-2fsht3tyca-ew.a.run.app';
}
